import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  getReferences() {
    return axios.get(`${i18n.locale}/api/public/msu/references`)
  },
  getAuthorities(params) {
    return axios.get(`${i18n.locale}/api/public/msu/authorities`, { params })
  },
  getAuthority(id) {
    return axios.get(`${i18n.locale}/api/public/msu/authorities/${id}`)
  },
  getMap(params) {
    return axios.get(`${i18n.locale}/api/public/msu/map`, { params })
  }
}
